export const METRIC_KEY = 'metricKey';
export const DISPLAY_MODE = 'displayMode';
export const FILTER_SET_ID = 'filterSet';
export const GAME_ID = 'gameId';
export const FILTERS_TAB = 'filtersTab';
export const PLAYER_ID = 'playerId';
export const TEAM_ID = 'teamId';
export const RADAR_TEMPLATE = 'radarTemplate';
